export function hasTag(el, tagName) {
  // @ts-ignore
  return el.localName === tagName;
}